import React from 'react'

const CityStatistics = ({t,lang,cityStatistics}) => {
  return (
    <div className="chart-card">
      <div className="chart-card-header">
        <strong>{t("cityStatistics")}</strong>
        <i class="fas fa-ellipsis-vertical d-none"></i>
      </div>
      <div className="chart-card-body mt-1">
        <table className="table">
          <thead>
            <tr>
              <th>{t("city")}</th>
              <th>{t("noOfTrips")}</th>
              <th>{t("noOfProviders")}</th>
              <th>{t("noOfBookings")}</th>
              <th>{t("revenue")}</th>
            </tr>
          </thead>
          <tbody>
            {cityStatistics?.map((city, index) => (
              <tr key={index}>
                <td>{city.name[lang]}</td>
                <td>{city.noOfTrips}</td>
                <td>{city.noOfProviders}</td>
                <td>{city.noOfBookings}</td>
                <td>{city.revenue}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default CityStatistics